export const enum ReactHookFormMode {
  ON_BLUR = 'onBlur',
  ON_CHANGE = 'onChange',
  ON_SUBMIT = 'onSubmit',
  ON_TOUCHED = 'onTouched',
  ALL = 'all'
}
